import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid gap-3"
}
const _hoisted_2 = { class: "border-secondary grid gap-3 rounded-md border p-2.5" }

import DeleteButton from '@/components/DeleteButton.vue';
    import type { Employee } from '@/types';
    import { useI18n } from 'vue-i18n';
    import { formatCurrency, formatDate } from '@/utils/helpers';
    import {
        Table,
        TableHeader,
        TableBody,
        TableRow,
        TableCell,
        TableHead,
    } from '@/components/ui/table';
    import { ref } from 'vue';
    import { Label } from '@/components/ui/label';
    import { type InertiaForm } from '@inertiajs/vue3';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeEmploymentSalaryChangesTable',
  props: {
    employee: {},
    form: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

    const futureSalaryChanges = ref(props.employee.employment.future_salary_changes || []);

    const deleteFutureSalaryChange = (future_salary_change: { id: number }) => {
        props.form.employment.deleted_future_salary_changes.push(future_salary_change.id);

        futureSalaryChanges.value = futureSalaryChanges.value.filter(
            (item: { id: number }) => item.id !== future_salary_change.id,
        );
    };

return (_ctx: any,_cache: any) => {
  return (!!futureSalaryChanges.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Label), null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('employee.employment.future_salary_changes')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Table), null, {
            default: _withCtx(() => [
              _createVNode(_unref(TableHeader), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(TableRow), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TableHead), { class: "h-8" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('employee.employment.salary')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(TableHead), { class: "h-8" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('employee.employment.future_salary_starts_at')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(TableHead), { class: "h-8" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(TableBody), null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(futureSalaryChanges.value, (future_salary_change) => {
                    return (_openBlock(), _createBlock(_unref(TableRow), {
                      key: future_salary_change.id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(TableCell), { class: "h-8" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(formatCurrency)(future_salary_change.amount)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(TableCell), { class: "h-8" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(formatDate)(future_salary_change.starts_at)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(TableCell), { class: "h-8 w-0 py-1 whitespace-nowrap" }, {
                          default: _withCtx(() => [
                            _createVNode(DeleteButton, {
                              onClick: ($event: any) => (deleteFutureSalaryChange(future_salary_change))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})